import '../../sass/blocks/custom/interactive/_slideshow.scss'
require('../../js/blocks/slideshow.js');